import ViewController from '../../core/viewController';

import ListView from "../../view/component/listView/listView";

import AdminModel from "../../model/admin";

import Formatter from '../../helper/formatter';
import appConfigs from '../../config/appConfigs';

import Session from '../../helper/session';

export default class AdminViewController extends ViewController 
{
    constructor(props) {
		super(props);

		this.state =
		{
            list: [],
            isMainOpenDropdown:false,
			mainLabel:this.i18n('getAdmain'),
            totelOfAdmain:0,
            loadMore:false,
        }

        this._shouldLoadMoreAdmain = true;
		this._pageNumberAdmain = 1;
		this._itemFormForAdmin = 1;
        this._itemToForAdmin = 25;
        this._currentTimestamp = Formatter?.getCurrentDate();

        this._listOfMainDropdown = 
        [
			{ "value": "driver", "label": this.i18n('title_driver')},
        ];

        this._mainColForAdmin = 
        [
            { title: this.i18n('common_id'), isHidden: false },
            { title: this.i18n('common_name'), isHidden: false },
            { title: this.i18n('common_mobile'), isHidden: true },
            { title: "", isHidden: false }
        ];

        this._listOfKeysForAdmin = 
        [
            { key: "id", isBoolean: false, boolTrue: "", boolFalse: "", needTranslation: false, translation: "",needDateFormatter:false, isHidden: false },
            { key: "name", isBoolean: false, boolTrue: "", boolFalse: "", needTranslation: false, translation: "",needDateFormatter:false, isHidden: false },
		    { key: "mobile", isBoolean: false, boolTrue: this.i18n('common_closed'), boolFalse: this.i18n('common_active'), needTranslation: false, translation: "", isHidden: true },
        ];

       
    }

    loadContentAdmin(type)
	{
		if (type === "more") {
			if (this._itemToForAdmain < this.state?.totelOfAdmain) {
				if (this._shouldLoadMoreAdmain && this.state?.list?.length > 0) {
					this._shouldLoadMoreAdmain = false;
					this._itemFormForAdmain += 25;
					this._itemToForAdmain += 25;
					this._pageNumberAdmain += 1;
					this._isMounted && this.getAdmain();
				}
			}
		}
		else {
			if (this._pageNumberAdmain > 1) 
            {
				this._pageNumberAdmain -= 1;
				this._itemFormForAdmain -= 25;
				this._itemToForAdmain -= 25;
				this._shouldLoadMoreAdmain = false;
				this._isMounted && this.getAdmain();
			}
		}
    }

    getAdmain() 
	{
		this._isMounted && this.startLoading();
		this._isMounted && AdminModel
		?.getAll(this._pageNumberAdmain, this._currentTimestamp)
		.then(async data => 
		{
			if(parseInt(data?.result) === 1)
            {
                if(data?.data?.length < appConfigs.itemTo )
				{
					if(data?.length !==0)
					{
						this._isMounted && this.setState({ ...this.state, loadMore:false, list: data?.data, totelOfAdmain: data?.count});
				    }
					else
					{
						this._isMounted && this.setState({ ...this.state, loadMore:false});
					}
				}
				else
				{
					this._isMounted && this.setState({ ...this.state, loadMore:true, list: data?.data, totelOfAdmain: data?.count });
				}
                this._isMounted && this.stopLoading();
            }
            else
            {
                this._isMounted && this.showErrMsg(data?.message, "error");
            }
		})
		.catch(e => {
			this._isMounted && this.stopLoading();
		});
    }

    handleClickEvent(id)
    {
        this.props?.history?.push(`/admin/${id}`);
    }
    
    viewControllerDidMount()
	{
        this.setTitle("title_admin");
        this._isMounted && this.getAdmain();
    }

    handleChangeFristButton()
    {
        this.props?.history?.push(`/addAdmin`);
    }

    render()
    {
        // Session.setLoggedIn(); 

        if(Session.isLoggedIn())
        {
        return (
            <ListView
                viewIsLoading={this.state?.viewIsLoading}
                shouldShowMainDropdown={true}
                isMainOpenDropdown={this.state?.isMainOpenDropdown}
                mainLabel={this.state?.mainLabel}
                listOfMainDropdown={this._listOfMainDropdown}
                title={this.i18n('title_admin')}
                shouldShowFristFilter={false}
                shouldShowSecondFilter={false}
                shouldShowThirdFilter={false}
                shouldShowFristButton={true}
                placeholderFristButton={this.i18n('title_admin')}
                
                identifier={"id"}

                mainCol={this._mainColForAdmin}
                items={this.state?.list}
                listOfKeys={this._listOfKeysForAdmin}

                numberOfItem={this.state?.totelOfAdmain}
                itemFrom={this._itemFormForAdmin}
                itemTo={this._itemToForAdmin }
                pageNumber={this._pageNumberAdmin}

                handleClickEvent={this.handleClickEvent.bind(this)}
                handleChangeFristButton={this.handleChangeFristButton.bind(this)}
                loadContent={this.loadContentAdmin.bind(this)}
                
            />
        )
        }
        else
        {
            window.location.href = "/login";
        }
    }
}